import { IDailyMission, IStateMissions } from '../../../../State/reducers/missions';
import { Power1, TweenMax } from 'gsap';
import { MissionMilestoneBar } from './MissionMilestoneBar';
import { MissionTab } from './MissionTab';
import { getMilestoneReward, MISSION_MILESTONE_TOTAL } from '../../../../Config/Missions';
import { HudActions, HudEmitter } from '../../../../Managers/Hud/HudEmitter';

export class DailyMissions extends PIXI.Container {
    private containerWidth: number;
    private containerHeight: number;
    private milestoneBar: MissionMilestoneBar;
    private missionTabs: MissionTab[];
    private completeCount: number;
    private showReward: () => Promise<any>;

    constructor(
        pageWidth: number,
        pageHeight: number,
        missions: IDailyMission[],
        completeCount: number,
        showReward: () => Promise<any>,
        milestone: number
    ) {
        super();

        this.containerWidth = pageWidth;
        this.containerHeight = pageHeight;
        this.showReward = showReward;
        this.completeCount = completeCount;

        // mission milestone bar
        this.milestoneBar = new MissionMilestoneBar(this.completeCount / MISSION_MILESTONE_TOTAL);
        this.milestoneBar.y = -this.containerHeight * 0.18;
        this.milestoneBar.x = pageWidth * 0.5;
        this.addChild(this.milestoneBar);

        this.createContent(missions, this.containerHeight * 0.2);
        this.showContent();
    }

    public update(missionState: IStateMissions) {
        this.missionTabs.forEach((tab, index) => {
            tab.updateMissionInfo(missionState.missions[index], missionState.refreshTimer);
        });

        if (missionState.completedCount !== this.completeCount) {
            this.completeCount = missionState.completedCount;
            this.milestoneBar.progress = this.completeCount / MISSION_MILESTONE_TOTAL;

            // determine if coins animation or reward present needed
            const milestone = this.getLastMilestoneReached(this.completeCount);
            if (milestone > missionState.milestone) {
                // show animations....
                this.milestoneBar.playCoinAnimation(milestone, getMilestoneReward(milestone).val);
                HudEmitter.instance.emit(HudActions.MISSION_MILESTONE_COLLECTED, milestone);
                // emit milestone reached....
                if (milestone === 3) {
                    this.showReward().catch(err => {
                        console.log(['error with show reward in update daily', err]);
                    });
                }
                // need show reward from journal popup...
            }
        }
    }

    public cleanUp() {
        TweenMax.killChildTweensOf(this, true);
        this.destroy();
    }

    private createContent(missions: IDailyMission[], tabHeight: number) {
        this.missionTabs = missions.map((mission, index) => {
            const tab = new MissionTab(mission, this.containerWidth, this.containerHeight * 0.2);
            tab.pivot.set(tab.width / 2, 0);
            tab.x = this.width / 2 + tab.width * 0.005;
            tab.y = index * tabHeight + tabHeight * 0.02;
            tab.scale.set(0.9);

            return tab;
        });
    }

    private showContent() {
        this.missionTabs.forEach((tab, index) => {
            this.addChild(tab);

            TweenMax.to(tab.scale, 0.2, {
                delay: 0.1 * index + 0.2,
                ease: Power1.easeOut,
                x: 1,
                y: 1,
            });
        });
    }

    private getLastMilestoneReached(count: number) {
        if (count === MISSION_MILESTONE_TOTAL) {
            return 3;
        }

        if (count / MISSION_MILESTONE_TOTAL >= 0.6) {
            return 2;
        }

        if (count / MISSION_MILESTONE_TOTAL >= 0.3) {
            return 1;
        }

        return 0;
    }
}
